import { useQuery } from "@tanstack/react-query";
import { fetchUserAccount } from "@/services/userAccountApi";

export const useUserAccount = () =>
  useQuery({
    queryKey: ["user-account"],
    queryFn: fetchUserAccount,
    retry: false,
  });
